class FloatHelper {
    static toFixedFloat = (number: number|undefined, numberOfDecimals = 2): number|undefined => {
        if(number === undefined || number.toString() === '')  return undefined;
        return parseFloat(Number(number).toFixed(numberOfDecimals));
    };
}

export default FloatHelper;
